import { ErrorCode } from "./enums";

export interface IBreadcrumb {
  message: string; // Description of the action
  timestamp: Date; // When the action occurred
  metadata?: any; // Optional extra data (button id, page url, etc.)
}

export class HandledError extends Error {
  code: ErrorCode;
  description: any;

  constructor(error: Error | string, code: ErrorCode) {
    if (typeof error === "string") {
      super(error);
      this.name = "HandledError";
      this.description = error;
    } else {
      super(error.message);
      this.name = error.name;
      this.stack = error.stack;
      this.description = error;
    }
    this.code = code;
    return this;
  }

  public toObject() {
    return {
      code: this.code,
      name: this.name,
      message: this.message,
      stack: this.stack,
      description: this.description,
    };
  }

  public toString(): string {
    return JSON.stringify({
      code: this.code,
      name: this.name,
      message: this.message,
      stack: this.stack,
      description: this.description,
    });
  }
}
